import * as yup from "yup";

export const basicSchema = yup.object().shape({
  username: yup.string()
  .min(5, "Username should be at least 5 characters long")
  .required("Required"),
  password: yup
    .string()
    .required("Required"),
});